"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var merch_react_hooks_1 = require("@carvana/merch-react-hooks");
var useSearchBarEvents_1 = __importDefault(require("./useSearchBarEvents"));
var constants_1 = require("../constants");
var SearchBarContext_1 = require("../SearchBarContext");
var utils_1 = require("../utils");
function useFetchSuggestions() {
    var _a = (0, SearchBarContext_1.useSearchBarContext)(), apiBaseUrl = _a.apiBaseUrl, onSuggestApiError = _a.onSuggestApiError, setNoResults = _a.setNoResults, suggestionQuery = _a.suggestionQuery, trackEvent = _a.trackEvent;
    var searchBarEvents = (0, useSearchBarEvents_1.default)(trackEvent);
    var _b = (0, merch_react_hooks_1.useLoadableState)([]), data = _b.data, isLoading = _b.isLoading, setLoading = _b.setLoading, setData = _b.setData;
    (0, merch_react_hooks_1.useEffectWithController)(function (controller) {
        function fetchData() {
            return __awaiter(this, void 0, void 0, function () {
                var response, suggestions, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setLoading();
                            if (!suggestionQuery) {
                                setData([]);
                                return [2 /*return*/];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, fetch("".concat(apiBaseUrl).concat(constants_1.GET_SUGGESTIONS_V3, "?query=").concat(suggestionQuery), { signal: controller.signal })];
                        case 2:
                            response = _a.sent();
                            if (!response.ok) {
                                throw new Error(response.statusText);
                            }
                            return [4 /*yield*/, response.json()];
                        case 3:
                            suggestions = (_a.sent()).suggestions;
                            if (suggestions.length === 0 && suggestionQuery.length > 0) {
                                setNoResults(true);
                                searchBarEvents.noResults(suggestionQuery);
                            }
                            else {
                                setNoResults(false);
                            }
                            setData((0, utils_1.normalizeFetchedSuggestions)({
                                inputValue: suggestionQuery,
                                searchType: constants_1.SearchType.TextSearch,
                                data: suggestions
                            }));
                            return [3 /*break*/, 5];
                        case 4:
                            err_1 = _a.sent();
                            if (controller.signal.aborted)
                                return [2 /*return*/];
                            if (onSuggestApiError) {
                                onSuggestApiError(err_1);
                            }
                            else {
                                console.error(err_1);
                            }
                            setData([]);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        void fetchData();
    }, [
        apiBaseUrl,
        onSuggestApiError,
        searchBarEvents,
        setData,
        setLoading,
        setNoResults,
        suggestionQuery
    ]);
    return { data: data, isLoading: isLoading };
}
exports.default = useFetchSuggestions;
//# sourceMappingURL=useFetchSuggestions.js.map